





































import { Component, Vue } from "@/shared/vuepack";
import Paginator from "@/shared/components/ui/Paginator.vue";
import HsabExpenseCardRow from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRow.vue";
import HsabExpenseCardColumns from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardColumns.vue";
import { useManagedExpenseStore } from "@/employee/store/managedExpense";

@Component({
  components: {
    HsabExpenseCardColumns,
    HsabExpenseCardRow,
    Paginator,
  }
})
export default class ManagedExpenseTable extends Vue {
  managedExpensesStore = useManagedExpenseStore();

  get currentPage () {
    return this.managedExpensesStore.currentPageNumber;
  }

  get pageCount () {
    return this.managedExpensesStore.totalPageCount;
  }

  get hasPages () {
    return this.managedExpensesStore.totalPageCount > 0;
  }

  get loaded () {
    return this.managedExpensesStore.isCurrentPageLoaded;
  }

  get loading () {
    return this.managedExpensesStore.isCurrentPageLoading;
  }

  get items () {
    return this.managedExpensesStore.currentPageItems;
  }

  get showPlanNameColumn () {
    return !this.managedExpensesStore.currentBaseFilerIsRecurringExpenses;
  }

  get showSourceColumn () {
    return !this.managedExpensesStore.currentBaseFilerIsRecurringExpenses;
  }

  get showCategoryColumn () {
    return this.managedExpensesStore.currentBaseFilerIsRecurringExpenses;
  }

  get showScheduleDescriptionColumn () {
    return this.managedExpensesStore.currentBaseFilerIsRecurringExpenses;
  }

  onSwitchPage (pageNumber: number) {
    this.managedExpensesStore.loadManagedExpensesByPage(pageNumber);
  }
}
